export default [
  {
    path: "/adyen/payment-check/:transactionID",
    name: "adyenPaymentCheck",
    component: () => import(/* webpackChunkName: "payment" */ "@/views/payment/checkPayment.vue"),
  },
  {
    path: "/adyen/payment-success",
    name: "adyenPaymentSuccess",
    component: () => import(/* webpackChunkName: "payment" */ "@/views/payment/checkPaymentSuccess.vue"),
  },
  {
    path: "/adyen/payment-failed",
    name: "adyenPaymentError",
    component: () => import(/* webpackChunkName: "payment" */ "@/views/payment/checkPaymentFailed.vue"),
  },
]
